import React, { memo } from 'react';
import './CategoryTag.css';

const CategoryTag = memo(({ category, isActive, onClick, size = 'normal' }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick && category) {
      onClick(category);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleClick(e);
    }
  };

  return (
    <span 
      className={`category-tag ${isActive ? 'active' : ''} ${size}`}
      data-category={category}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
    >
      {category}
    </span>
  );
});

CategoryTag.displayName = 'CategoryTag';

export default CategoryTag;